import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaitingBallCloakComponent } from './waiting-ball-cloak.component';

@NgModule({
  declarations: [
    WaitingBallCloakComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    WaitingBallCloakComponent
  ]
})
export class WaitingBallCloakModule { }
